import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { navbarWidths } from './config';
import { classes } from './styles';
import AppMenu from './Components/AppMenu/AppMenu';
import NavigationItems from './Components/NavigationItems/NavigationItems';
import ExpandCollapseButton from './Components/ExpandCollapseButton';
import AIStudioModal from '../../../AIStudio/AIStudioModal/AIStudioModal';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

const Navbar = ({
  isAdminUser,
  aiStudioSettings,
  newEngageEnabled
}: {
  isAdminUser: boolean;
  aiStudioSettings: {
    aiStudioEnabled: boolean;
    aiSummariesEnabled: boolean;
    aiStudioFrenchEnabled: boolean;
  };
  newEngageEnabled: boolean;
}) => {
  const [navbarState, setNavbarState] = useState<keyof typeof navbarWidths>(
    (localStorage.getItem('navbarState') as keyof typeof navbarWidths) || 'expanded'
  );
  const [childState, setChildState] = useState<[number, null | HTMLElement]>([-1, null]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 866) {
        setNavbarState('collapsed');
        localStorage.setItem('navbarState', 'collapsed');
      } else {
        setNavbarState('expanded');
        localStorage.setItem('navbarState', 'expanded');
        setChildState([-1, null]);
      }
    };

    !localStorage.getItem('navbarState') && handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Box id="react-navbar">
        <ExpandCollapseButton
          navbarState={navbarState}
          setNavbarState={setNavbarState}
          setChildState={setChildState}
        />
        <Box sx={{ ...classes.navbarContainer, width: `${navbarWidths[navbarState]}px` }}>
          <AppMenu navbarState={navbarState} />
          <NavigationItems
            navbarState={navbarState}
            childState={childState}
            setChildState={setChildState}
            isAdminUser={isAdminUser}
            aiStudioEnabled={aiStudioSettings.aiStudioEnabled}
            newEngageEnabled={newEngageEnabled}
          />
          <AIStudioModal
            aiStudioEnabled={aiStudioSettings.aiStudioEnabled}
            aiSummariesEnabled={aiStudioSettings.aiSummariesEnabled}
            aiStudioFrenchEnabled={aiStudioSettings.aiStudioFrenchEnabled}
            navbarState={navbarState}
            isSidebarTrigger
          />
        </Box>
      </Box>
    </QueryClientProvider>
  );
};

export default Navbar;
